import { setLoadedState, setErrorState } from 'gleam-shared/browser/whenStateChanges'

// the name of the option rather than the name of the function is twisted because you can give this function any name while importing
// the name of the option is inspired by https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml

const injected = new Map()

export default function injectScript({ dangerousScript, marker, once }) {
  if (!dangerousScript) {
    return Promise.reject(new Error('A script is not given!'))
  }

  if (once) {
    return injectScriptOnce(dangerousScript, marker)
  } else {
    return injectScriptAgain(dangerousScript, marker)
  }
}

function injectScriptOnce(src, marker) {
  if (findScript(src)) {
    const promise = injected.get(src)

    if (promise) {
      return promise
    } else {
      return Promise.reject(new Error(`${src} had already been injected!`))
    }
  }

  const script = appendScript(src, marker)
  const promise = promiseScriptLoads(script)

  promise.catch(onError)
  injected.set(src, promise)

  return promise

  function onError() {
    script.remove()
    injected.delete(src)
  }
}

function injectScriptAgain(src, marker) {
  return promiseScriptLoads(appendScript(src, marker))
}

function findScript(src) {
  return document.querySelector(`script[src="${src}"]`)
}

function appendScript(src, marker) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = src

  if (marker) {
    script.dataset.marker = marker
  }

  document.head.appendChild(script)
  return script
}

function promiseScriptLoads(script) {
  return new Promise((resolve, reject) => {
    script.addEventListener('load', onLoad, { once: true })
    script.addEventListener('error', onError, { once: true })

    function onLoad() {
      script.removeEventListener('error', onLoad)
      setLoadedState(script)
      script.dataset.loaded = true
      resolve()
    }

    function onError() {
      const error = new Error(`${script.src} failed to load!`)
      script.removeEventListener('load', onError)
      setErrorState(script, error)
      reject(error)
    }
  })
}
